module.exports = __webpack_public_path__ + "img/thumbnail_AmurLeopard_f_melanistic.2a5426ce.png";